"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabeledControlMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Checkbox = require("../../components/Checkbox/Checkbox.styles");
var _Label = require("../../components/Label/Label.styles");
var _Radio = require("../../components/Radio/Radio.styles");
var _Switch = require("../../components/Switch/Switch.styles");
var _SwitchWrapper = require("../../components/SwitchWrapper/SwitchWrapper.styles");
var _constants = require("../../constants");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
var fluidCSS = function fluidCSS(_ref) {
  var fluid = _ref.fluid;
  if (fluid) {
    return "justify-content: space-between;";
  }
  return '';
};
var positionCSS = function positionCSS(props) {
  if (props.labelPosition === _constants.LABELED_CONTROL_POSITIONS.left) {
    return (0, _styledToken.default)('LabeledControl.Label.paddingRight', function (paddingRight) {
      return (0, _styledComponents.css)(["> ", "{order:-1;padding-right:", ";}"], _Label.StyledLabel, paddingRight ? paddingRight + "px" : (0, _spaceMixin.spaceMixin)('xs')(props));
    })(props);
  }
  return (0, _styledToken.default)('LabeledControl.Label.paddingLeft', function (paddingLeft) {
    return (0, _styledComponents.css)(["> ", "{padding-left:", ";}"], _Label.StyledLabel, paddingLeft ? paddingLeft + "px" : (0, _spaceMixin.spaceMixin)('xs')(props));
  })(props);
};

// Calculates the offset of components based on the desired height.
// The desired height is the height when the label spans only one line;
// when the label spans multiple lines, we need to make sure we maintain the correct padding.
var offsetCSS = function offsetCSS(_ref2) {
  var size = _ref2.size;
  return (0, _styledToken.default)({
    desiredHeight: 'LabeledControl.desiredHeight',
    switchHeight: "Switch.sizes." + size + ".height",
    radioHeight: 'Radio.size',
    lineHeights: 'lineHeights',
    fontType: 'LabeledControl.fontType'
  }, function (_ref3) {
    var desiredHeight = _ref3.desiredHeight,
      switchHeight = _ref3.switchHeight,
      radioHeight = _ref3.radioHeight,
      lineHeights = _ref3.lineHeights,
      fontType = _ref3.fontType;
    var labelHeight = lineHeights && lineHeights[fontType];
    var radioOffset = (desiredHeight - radioHeight) / 2;
    var labelOffset = (desiredHeight - labelHeight) / 2;
    var switchOffset = (desiredHeight - switchHeight) / 2;
    return (0, _styledComponents.css)(["> ", ",> ", "{margin-top:", "px;}> ", "{margin-top:", "px;}> ", "{padding-top:", "px;padding-bottom:", "px;}"], _Checkbox.StyledCheckbox, _Radio.StyledRadio, radioOffset, _SwitchWrapper.StyledSwitchWrapper, switchOffset, _Label.StyledLabel, labelOffset, labelOffset);
  });
};

/** @class LabeledControlMixin */
/** @method */
var LabeledControlMixin = function LabeledControlMixin(props) {
  return (0, _styledToken.default)({
    fontType: 'LabeledControl.fontType',
    switchBackgroundColorHover: 'Switch.backgroundColorHover',
    switchBackgroundColorCheckedHover: 'Switch.backgroundColorCheckedHover',
    switchBorderColor: 'Switch.borderColor',
    switchBorderColorHover: 'Switch.borderColorHover'
  }, function (_ref4) {
    var fontType = _ref4.fontType,
      switchBackgroundColorHover = _ref4.switchBackgroundColorHover,
      switchBackgroundColorCheckedHover = _ref4.switchBackgroundColorCheckedHover,
      switchBorderColor = _ref4.switchBorderColor,
      switchBorderColorHover = _ref4.switchBorderColorHover;
    return (0, _styledComponents.css)(["display:flex;> ", ":after{content:none;}> ", ",> ", ",> ", "{flex-shrink:0;}> ", ",> ", ",> ", "{~ ", "{", "}}&:hover{", ":not([aria-disabled='true']){background-color:", ";border-color:", ";}", ":checked + ", ":not([aria-disabled='true']){background-color:", ";border-color:", ";}}", " ", " ", " ", ""], _Label.StyledLabel, _Checkbox.StyledCheckbox, _Radio.StyledRadio, _SwitchWrapper.StyledSwitchWrapper, _Checkbox.StyledCheckbox, _Radio.StyledRadio, _SwitchWrapper.StyledSwitchWrapper, _Label.StyledLabel, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), _Switch.StyledSwitch, switchBackgroundColorHover, switchBorderColorHover, _Checkbox.StyledCheckbox, _Switch.StyledSwitch, switchBackgroundColorCheckedHover, switchBorderColor, offsetCSS(props), fluidCSS(props), positionCSS(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.LabeledControlMixin = LabeledControlMixin;